import { Card, Grid, Typography } from '@material-ui/core';
import { createStyles, StyledComponentProps, Theme, withStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { Instance } from 'mobx-state-tree';
import moment from 'moment';
import * as React from 'react';
import { EntityImage } from '../../comps/EntityImage';
import { INamedEntity } from '../../main/entities';
import { transl } from '../../main/transl';
import { OcScreen } from '../OcScreen';
import { AdsDialog } from './AdsDialog';
import { AdsPageStore, specialOffersPageStore } from './AdsPageStore';

const styles = (theme: Theme) => createStyles({
	root: {
		...theme.mixins.gutters(),
		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(2),
		display: 'flex',
		justifyContent: 'left',
		alignItems: 'stretch',
	},
	card: {
		flex: 1,
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		minHeight: 350,
		maxHeight: 350,
		alignContent: 'stretch',
		textAlign: 'center',
	},
	imageDiv: {
		display: 'flex',
		flex: '1 1',
		padding: theme.spacing(1),
		alignSelf: 'center',
		maxHeight: '270px',
		overflow: 'hidden',
	},
	titleDiv: {
		margin: theme.spacing(0.5, 0.3),
	},
	footerDiv: {
		border: '2px solid #FF8888',
		borderRadius: 10,
		padding: 4,
		height: '30px',
		margin: theme.spacing(0.5, 0.3),
	},
	image: {
		width: 'auto',
		height: 'auto',
		maxWidth: '100%',
		maxHeight: '100%',
		objectFit: 'contain',
		display: 'block',
		marginLeft: 'auto',
		marginRight: 'auto'
	},
	title: {
	},
	footer: {
	}
});

function footerDiv(entity) {
	const a = moment.utc(entity.validUntil).local().startOf('day');
	const b = moment().startOf('day');
	const diff = a.diff(b, 'days');
	return diff<2 ? transl(diff<1 ? 'endsInDays0' : 'endsInDays1') : transl('endsInDays2', diff);
}

interface IMiniOfferProps {
	store: Instance<typeof AdsPageStore>
	entity: INamedEntity
}

@observer class _MiniOffer extends React.Component<IMiniOfferProps & StyledComponentProps> {
	_onClick = () => this.props.store.setAdvertisementId(this.props.entity.id)

	render() {
		const classes = this.props.classes || {};
		const {entity} = this.props;
		return <Grid item xs={12} sm={6} md={4} lg={3} onClick={this._onClick}>
			<Card className={classes.card}>
				<div className={classes.imageDiv}>
					<EntityImage entity={entity} className={classes.image} tooltip=""/>
				</div>
				<div className={classes.titleDiv}>
					<Typography variant="h5">{entity.name}</Typography>
				</div>
				<div className={classes.footerDiv}>
					<div className={classes.footer}>{footerDiv(entity)}</div>
				</div>
			</Card>
		</Grid>;
	}
}

const MiniOffer = withStyles(styles)(_MiniOffer);

interface IAdsPageProps {
	store: Instance<typeof AdsPageStore>
}

@observer class _AdsPage extends OcScreen<IAdsPageProps & StyledComponentProps> {
	name() {
		return 'AdsPage';
	}

	submenu() {
		return [];
	}

	allowScroll() {
		return true;
	}

	usedStores = () => [
		'Advertisement',
		'Branch',
		'Supplier',
		'Template',
		!this.props.store.templateId ? '' : 'TemplateItem:' + this.props.store.templateId,
		!this.props.store.itemId ? '' : 'AdvertiserOfferInCatalogs:' + this.props.store.itemId,
		...(this.props.store.templates.map(t => 'TemplateItem:' + t.id))
	]

	componentDidMount() {
		super.componentDidMount();
		this.props.store.init();
	}

	renderBody() {
		const classes = this.props.classes || {};
		const {store} = this.props;
		return <Grid container spacing={8} alignItems="stretch" className={classes.root}>
			{
				store.allAdvertisements.map(e => <MiniOffer store={store} key={e.id} entity={e}/>)
			}
			<AdsDialog store={store} entity={store.advertisement}/>
		</Grid>;
	}
}

const _AdsPage2 = withStyles(styles)(_AdsPage);

@observer export class AdsPage extends OcScreen<any> {
	render() {
		return <_AdsPage2 store={specialOffersPageStore}/>;
	}
}
